import { NavLink, Outlet } from 'react-router-dom';
import clsx from 'clsx';
import { Gamepad2, LayoutDashboard, Users } from 'lucide-react';

const tabs = [
  { to: '/admin', label: 'Дашборд', icon: LayoutDashboard, end: true },
  { to: '/admin/users', label: 'Пользователи', icon: Users, end: false },
  { to: '/admin/games', label: 'Матчи', icon: Gamepad2, end: false },
];

export function AdminLayout() {
  return (
    <div className="mx-auto max-w-6xl px-4 py-6">
      <div className="mb-6 flex items-center gap-1 overflow-x-auto rounded-xl border border-white/5 bg-ink-900/70 p-1">
        {tabs.map(({ to, label, icon: Icon, end }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            className={({ isActive }) =>
              clsx('flex items-center gap-2 whitespace-nowrap rounded-lg px-3 py-2 text-sm', isActive ? 'bg-white/10 text-white' : 'text-zinc-400 hover:text-white')
            }
          >
            <Icon className="h-4 w-4" /> {label}
          </NavLink>
        ))}
      </div>
      <Outlet />
    </div>
  );
}
